import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface JobStatus {
  id: number;
  object_name: string;
  label?: string;
  date_requested: string;
  started_at: string;
  status: 'generating' | 'complete' | 'failed' | 'expired';
  export_format?: string;
  download_url?: string;
  latest_document_url?: string;
  job_purpose: string[];
  parameters?: {
    graphql_context?: {
      format?: string;
    };
  };
}

export interface JobStatusResponse {
  job_statuses: JobStatus[];
  count: number;
  offset: number;
  next: string | null;
  previous: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class JobsStatusService {
  constructor(private readonly httpClient: HttpClient) {}

  getJobsStatus(page: number = 1, per_page: number = 20): Observable<JobStatusResponse> {
    const params = new HttpParams()
      .append('job_purpose[]', 'object_export')
      .append('job_purpose[]', 'object_report')
      .append('page', page.toString())
      .append('per_page', per_page.toString());

    return this.httpClient.get<JobStatusResponse>('job_statuses', { params });
  }

  getJobStatusById(id: number): Observable<JobStatus> {
    const params = new HttpParams().append('job_purpose[]', 'object_export').append('job_purpose[]', 'object_report');

    return this.httpClient
      .get<{ job_status: JobStatus }>(`job_statuses/${id}`, { params })
      .pipe(map((response) => response.job_status));
  }
}
